import { Helper } from '../classes/helper';
import { ModelHelper } from '../classes/model-helper';
import { AdditionalOrderInformationType } from '../enums/additional-order-information-type';

export class AdditionalOrderInformationTemplate {
	uid: string;
	id: string;
	type: AdditionalOrderInformationType;
	possibleValues: string;
	position: number;
	name: string; // description
	isMandatory: boolean;
	isActivated: boolean;
	defaultValue: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns AdditionalOrderInformationTemplate
	 */
	static map(
		data: any,
		item: AdditionalOrderInformationTemplate = new AdditionalOrderInformationTemplate()
	): AdditionalOrderInformationTemplate {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return AdditionalOrderInformationTemplate
	 */
	public map(data: any): AdditionalOrderInformationTemplate {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'id');
		ModelHelper.map(data, this, 'type');
		ModelHelper.map(data, this, 'possibleValues');
		ModelHelper.map(data, this, 'position');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'isMandatory');
		ModelHelper.map(data, this, 'isActivated');
		ModelHelper.map(data, this, 'defaultValue');

		// Extra check for type text
		if (this.type === 'TEXT') {
			this.possibleValues = Helper.getPositiveNumber(this.possibleValues) + '';
		}

		return this;
	}
}
